import { useContext } from 'react';

import { FlagsClient } from './create-flags-client';
import { FlagsContext } from './flags.context';

export function useFlagsClient(): FlagsClient {
  const client = useContext(FlagsContext);

  if (!client) {
    throw new Error('useFlagsClient must be used within a <FlagsProvider>');
  }

  return client;
}
